import React from "react";

const situationColors: { [key: string]: string } = {
  Agendado: "#FAFAD2", // GELO
  Presente: "#4CAF50",
  Falta: "#FF5252",
  "Sai após este atendimento": "#FFEB3B",
  Avaliação: "#FFA726",
  Devolutiva: "#D3D3D3",
  "Troca de horário ou terapeuta": "#0D47A1",
  Encaixe: "#BA68C8",
  "Desmarcado pela clínica": "#FF4081",
  "Controle Interno": "#64B5F6",
};

const Legend: React.FC = () => {
  const legendItems = Object.entries(situationColors);

  return (
    <div className="legend-container">
      {legendItems.map(([situation, color]) => (
        <div className="legend-item" key={situation}>
          <span className="color-box" style={{ backgroundColor: color }}></span>
          <span className="legend-text">{situation}</span>
        </div>
      ))}
      <style>{`
        .legend-container {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
          gap: 6px; /* Espa?amento entre os itens */
          max-width: 100%;
          width: 100%;
          margin: 0; /* Alinha ? esquerda */
          justify-items: start;
          align-items: start;
        }
        .legend-item {
          display: flex;
          align-items: flex-start;
          font-size: 0.8rem;
          padding: 2px 4px;
          white-space: normal;
          overflow-wrap: anywhere;
          word-break: break-word;
          line-height: 1.2;
          text-align: left;
        }
        .color-box {
          width: 15px;
          height: 15px;
          display: inline-block;
          margin-right: 5px;
          flex: 0 0 auto;
        }
        .legend-text {
          display: block;
          text-align: left;
        }

        @media (max-width: 768px) {
          .legend-container {
            grid-template-columns: repeat(2, minmax(140px, 1fr));
          }
          .legend-item {
            font-size: 0.75rem;
          }
        }

        @media (max-width: 360px) {
          .legend-container {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </div>
  );
};

export default Legend;
